exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Courses-module__wrapper___2qnyy{display:grid;grid-template-columns:repeat(auto-fill,minmax(225px,1fr));gap:1.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "Courses-module__wrapper___2qnyy"
};